import React, { useState, useEffect } from "react";
import Header from "../../../commons/Header/Header";
import Sidebar from "../../../commons/Sidebar/Sidebar";
import viewImage from "../../../assets/images/icons/view.svg";
import TeamImg from '../../../assets/images/login-bg.jpg';
import editImage from "../../../assets/images/icons/edit.svg";
import Star from "../../../assets/images/icons/star.svg";
import Profile from "../../../assets/images/profile.png";
import BlockIcon from "../../../assets/images/icons/block-icon.svg";
import FilterIcon from "../../../assets/images/icons/filter-icon.svg";
import Download from "../../../assets/images/icons/download-icon.svg";
import PDFIcon from "../../../assets/images/icons/pdf-icon.svg";
import Girl from "../../../assets/images/girl.jpg";
import { Link, useNavigate } from "react-router-dom";
import { handleApiCall } from "../../../apis";
import { endpoints } from "../../../utils/endpoints";
import { toast } from "react-toastify";
import Pagination from "react-bootstrap/Pagination";

import { Col, Row } from "react-bootstrap";

function Reviews() {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [data, setData] = useState([]);
  const [cms, setCms] = useState({ type: "publish" });
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [limit] = useState(5);
  const [totalPages, setTotalPages] = useState(1);

  const getList = async () => {
    setLoading(true);
    try {
      const query = new URLSearchParams({
        publish_status: cms?.type === "publish" ? 1 : 0,
        search,
        page,
        limit,
      }).toString();

      const response = await handleApiCall(
        "get",
        `${endpoints.teamList}?${query}`
      );
      if (response?.data?.code === 200) {
        setData(response?.data?.data?.team);
        setTotalPages(response?.data?.data?.totalPages || 1);
      } 
    } catch (error) {
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getList();
  }, [cms, page, search]);

  const block = async (status, id) => {
    try {
      const response = await handleApiCall("put", endpoints.teamBlock, {
        status,
        teamId: id,
      });
      if (response?.data?.code === 200) {
        toast.success(response?.data?.data?.message || "Team status updated!");
        getList();
      }
    } catch (error) {
      toast.error("Failed to update team status.");
    }
  };

  const deleteTeam = async (id) => {
    if (window.confirm("Are you sure you want to delete this team?")) {
      try {
        const response = await handleApiCall(
          "delete",
          `${endpoints.teamDelete}?teamId=${id}`
        );
        if (response?.data?.code === 200) {
          toast.success("Team deleted successfully!");
          getList();
        } 
      } catch (error) {
        toast.error("Error deleting team.");
      }
    }
  };
  
  const totalRatings = 886;
  const averageRating = 4.8;

  // Simulated rating data
  const ratings = [
    { stars: 5, count: 7000 },
    { stars: 4, count: 200 },
    { stars: 3, count: 300 },
    { stars: 2, count: 20 },
    { stars: 1, count: 10 },
  ];

  // Max count for progress bar reference
  const maxCount = Math.max(...ratings.map(r => r.count));

  return (
    <div className="container-scroller">
      <Header />
      <div className="container-fluid page-body-wrapper">
        <Sidebar />
        <div className="main-panel">
          <div className="content-wrapper">
            <div className="heading mb-3 d-flex align-items-center">
              <h3 className="text-default weight-400 my-0">Reviews</h3>
            </div>
            <div>
              <Row>
                <Col md='3' className="mt-0">
                  <Link to='/menu-and-restaurant/view-restaurant/' className="btn btn-default rounded-lg">Back</Link>
                </Col>
              </Row>
            </div>
            <div className="review_wrapper">
              <div className="p-3 border-1 rounded-14 mt-4">
                <div className="d-flex justify-content-between align-items-start">
                  <div className="d-flex align-items-center">
                    <img
                      src={Girl}
                      alt="User avatar"
                      className="rounded-circle me-2"
                      width="40"
                      height="40"
                    />
                    <div className="d-flex flex-column">
                      <div className="fw-bold">Carlos Ward</div>
                      <div className="text-warning small">
                        ★ ★ ★ ☆ ☆
                      </div>
                    </div>
                  </div>
                  <div className="text-muted small fw-semibold">20 May</div>
                </div>
                <div className="mt-2 text-muted" style={{ fontSize: '14px', lineHeight: '1.5' }}>
                  Lorem Ipsum, Or Lipsum As It Is Sometimes Know Lorem Ipsum, Or Lipsum As It Is Sometime This 
                  Lorem Ipsum, Or Lipsum As It Is Sometime On Lorem Ipsum, Or Lipsum As It Is Sometimes Know 
                  Lorem Ipsum, Or Lipsum As It Is Sometime This Lorem Ipsum, Or Lipsum As It Is Sometime On
                </div>
              </div>
              <div className="p-3 border-1 rounded-14 mt-4">
                <div className="d-flex justify-content-between align-items-start">
                  <div className="d-flex align-items-center">
                    <img
                      src={Girl}
                      alt="User avatar"
                      className="rounded-circle me-2"
                      width="40"
                      height="40"
                    />
                    <div className="d-flex flex-column">
                      <div className="fw-bold">Carlos Ward</div>
                      <div className="text-warning small">
                        ★ ★ ★ ☆ ☆
                      </div>
                    </div>
                  </div>
                  <div className="text-muted small fw-semibold">20 May</div>
                </div>
                <div className="mt-2 text-muted" style={{ fontSize: '14px', lineHeight: '1.5' }}>
                  Lorem Ipsum, Or Lipsum As It Is Sometimes Know Lorem Ipsum, Or Lipsum As It Is Sometime This 
                  Lorem Ipsum, Or Lipsum As It Is Sometime On Lorem Ipsum, Or Lipsum As It Is Sometimes Know 
                  Lorem Ipsum, Or Lipsum As It Is Sometime This Lorem Ipsum, Or Lipsum As It Is Sometime On
                </div>
              </div>
              <div className="p-3 border-1 rounded-14 mt-4">
                <div className="d-flex justify-content-between align-items-start">
                  <div className="d-flex align-items-center">
                    <img
                      src={Girl}
                      alt="User avatar"
                      className="rounded-circle me-2"
                      width="40"
                      height="40"
                    />
                    <div className="d-flex flex-column">
                      <div className="fw-bold">Carlos Ward</div>
                      <div className="text-warning small">
                        ★ ★ ★ ☆ ☆
                      </div>
                    </div>
                  </div>
                  <div className="text-muted small fw-semibold">20 May</div>
                </div>
                <div className="mt-2 text-muted" style={{ fontSize: '14px', lineHeight: '1.5' }}>
                  Lorem Ipsum, Or Lipsum As It Is Sometimes Know Lorem Ipsum, Or Lipsum As It Is Sometime This 
                  Lorem Ipsum, Or Lipsum As It Is Sometime On Lorem Ipsum, Or Lipsum As It Is Sometimes Know 
                  Lorem Ipsum, Or Lipsum As It Is Sometime This Lorem Ipsum, Or Lipsum As It Is Sometime On
                </div>
              </div>
              <div className="p-3 border-1 rounded-14 mt-4">
                <div className="d-flex justify-content-between align-items-start">
                  <div className="d-flex align-items-center">
                    <img
                      src={Girl}
                      alt="User avatar"
                      className="rounded-circle me-2"
                      width="40"
                      height="40"
                    />
                    <div className="d-flex flex-column">
                      <div className="fw-bold">Carlos Ward</div>
                      <div className="text-warning small">
                        ★ ★ ★ ☆ ☆
                      </div>
                    </div>
                  </div>
                  <div className="text-muted small fw-semibold">20 May</div>
                </div>
                <div className="mt-2 text-muted" style={{ fontSize: '14px', lineHeight: '1.5' }}>
                  Lorem Ipsum, Or Lipsum As It Is Sometimes Know Lorem Ipsum, Or Lipsum As It Is Sometime This 
                  Lorem Ipsum, Or Lipsum As It Is Sometime On Lorem Ipsum, Or Lipsum As It Is Sometimes Know 
                  Lorem Ipsum, Or Lipsum As It Is Sometime This Lorem Ipsum, Or Lipsum As It Is Sometime On
                </div>
              </div>
              <div className="p-3 border-1 rounded-14 mt-4">
                <div className="d-flex justify-content-between align-items-start">
                  <div className="d-flex align-items-center">
                    <img
                      src={Girl}
                      alt="User avatar"
                      className="rounded-circle me-2"
                      width="40"
                      height="40"
                    />
                    <div className="d-flex flex-column">
                      <div className="fw-bold">Carlos Ward</div>
                      <div className="text-warning small">
                        ★ ★ ★ ☆ ☆
                      </div>
                    </div>
                  </div>
                  <div className="text-muted small fw-semibold">20 May</div>
                </div>
                <div className="mt-2 text-muted" style={{ fontSize: '14px', lineHeight: '1.5' }}>
                  Lorem Ipsum, Or Lipsum As It Is Sometimes Know Lorem Ipsum, Or Lipsum As It Is Sometime This 
                  Lorem Ipsum, Or Lipsum As It Is Sometime On Lorem Ipsum, Or Lipsum As It Is Sometimes Know 
                  Lorem Ipsum, Or Lipsum As It Is Sometime This Lorem Ipsum, Or Lipsum As It Is Sometime On
                </div>
              </div>
              <div className="p-3 border-1 rounded-14 mt-4">
                <div className="d-flex justify-content-between align-items-start">
                  <div className="d-flex align-items-center">
                    <img
                      src={Girl}
                      alt="User avatar"
                      className="rounded-circle me-2"
                      width="40"
                      height="40"
                    />
                    <div className="d-flex flex-column">
                      <div className="fw-bold">Carlos Ward</div>
                      <div className="text-warning small">
                        ★ ★ ★ ☆ ☆
                      </div>
                    </div>
                  </div>
                  <div className="text-muted small fw-semibold">20 May</div>
                </div>
                <div className="mt-2 text-muted" style={{ fontSize: '14px', lineHeight: '1.5' }}>
                  Lorem Ipsum, Or Lipsum As It Is Sometimes Know Lorem Ipsum, Or Lipsum As It Is Sometime This 
                  Lorem Ipsum, Or Lipsum As It Is Sometime On Lorem Ipsum, Or Lipsum As It Is Sometimes Know 
                  Lorem Ipsum, Or Lipsum As It Is Sometime This Lorem Ipsum, Or Lipsum As It Is Sometime On
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Reviews;